import React, { useEffect, useRef } from "react";
import { Form, Formik, FormikProps } from "formik";
import * as Yup from "yup";
import Grid from "@material-ui/core/Grid/Grid";
import CustomButton from "../../../../../components/Button/CustomButton";
import ProductApi from "../../../../../api/services/ProductApi";
import useEnv from "../../../../../hooks/env";
import CompetitorProduct from "../../../../../api/models/product/CompetitorProduct";
import { ProductReferenceResponseWithType } from "../../../../../api/models/ProductReferenceResponse";
import useStyles from "./CompetitorSuggestionFromStyle";
import {
  CompetitorProductAutocomplete,
  CompetitorSampleAddFormProps,
  CompetitorSampleAddFormType,
} from "./CompetitorSuggestionForm";
import { getCompetitorProductFullName } from "../../forms/productReferenceHelper";

const createInitialValues = (preset: ProductReferenceResponseWithType | null | undefined) => {
  if (preset) {
    return {
      id: preset?.competitorProductId,
      name: preset?.competitorProductName || "",
      company: {
        id: preset?.competitorCompanyId,
        name: preset?.competitorCompanyName || "",
        contact: null,
      },
      color: null,
      adhesive: null,
      backing: null,
      thickness: null,
      tesaCoverName: null,
      attachments: [],
      creationDate: null,
    } as unknown as CompetitorProduct;
  }
  return null;
};

const CompetitorSampleAddFormRequester = (props: CompetitorSampleAddFormProps) => {
  const { api } = useEnv();
  const competitorSearch = useRef<{ reset: () => void }>(null);

  const productApi = new ProductApi(api);
  const classes = useStyles(props);
  const { hideSubmit, handleFormChange, handleSubmit, preset } = props;

  const yupValidationSchema = Yup.object().shape({
    product: Yup.string().required("Please select"),
  });

  return (
    <Formik<CompetitorSampleAddFormType>
      initialValues={{
        product: createInitialValues(preset),
      }}
      onSubmit={(values) => {
        if (handleSubmit) {
          handleSubmit(values);
        }
      }}
      validationSchema={yupValidationSchema}
    >
      {(formikProps: FormikProps<CompetitorSampleAddFormType>): JSX.Element => {
        const { errors, isSubmitting, setFieldValue, touched, values } = formikProps;

        useEffect(() => {
          if (handleFormChange) {
            handleFormChange(values);
          }
        }, [values]);

        return (
          <Form>
            <Grid container justify="flex-start" direction="row" spacing={4}>
              <Grid item xs={12}>
                <CompetitorProductAutocomplete
                  autoFocus
                  ref={competitorSearch}
                  inputLabel="Product"
                  map={(value): { key: string; label: string } => {
                    return {
                      key: `${value.id}`,
                      label: getCompetitorProductFullName(value?.name, value?.company?.name),
                    };
                  }}
                  optionFetch={(term: string) => {
                    return productApi.getCompetitorProduct(term, "").then((res) => res?.data);
                  }}
                  onChange={(e, value) => {
                    if (value === null) {
                      const name = (e.target as HTMLInputElement).value || null;
                      setFieldValue("product", name && { name });
                    } else {
                      setFieldValue("product", value);
                    }
                  }}
                  value={values.product}
                  error={!!(errors.product && touched.product)}
                />
              </Grid>
            </Grid>
            {!hideSubmit && (
              <Grid container item direction="row" justify="flex-end">
                <CustomButton
                  className={classes.marginTop}
                  disabled={isSubmitting}
                  primary
                  text="Add Competitor Product"
                  type="submit"
                />
              </Grid>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default CompetitorSampleAddFormRequester;
